<template lang="html">
  <div ref="partner" class="aha-row">
    <a class="no-line" :href="post.link" v-html="post.title" target="_blank"></a>
    <div v-if="post.files.length > 0" ref="logo" class="aha-logo">
      <img :src="post.files[0].url" :alt="post.title">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Partner',
  props: {
    post: Object
  },
  data () {
    return {
      show: false
    }
  },
  created () {
    window.addEventListener('scroll', this.inViewport)
  },
  destroyed () {
    window.removeEventListener('scroll', this.inViewport)
  },
  methods: {
    inViewport () {
      let hW = window.innerHeight / 2
      let center = window.scrollY + hW
      let top = this.$refs.partner.offsetTop - 4
      let height = top + this.$refs.partner.clientHeight + 4
      if (center > top && center < height) {
        this.$refs.partner.classList.add('active')
      } else {
        this.$refs.partner.classList.remove('active')
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
.aha-logo {
  position:fixed;
  top:0;
  left:0;
  width:50%;
  height:100vh;
  background-color:white;
  background-image: url('../assets/images/00_Fragezeichen.svg');
  background-repeat: no-repeat;
  background-position: center center;
  z-index:6;
  padding:$gap / 2;
  display:none;
  img {
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-65%);
    max-width:100%;
    max-height:80%;
    padding:$gap * 2;
    mix-blend-mode:multiply;
    @media only screen and (max-width: $phone) {
      padding: $gap;
    }
  }
  &.active {
    display:block;
  }
}
</style>
